import { CURRENCY } from 'src/types';

export enum LANGUAGE {
    ENGLISH = 'en',
    BULGARIAN = 'bg',
}

export enum PAYMENT_PROVIDER {
    MANUAL = 'manual',
    AUTOMATIC = 'automatic',
}

export type Customer = {
    id: string;
    tenant: {
        id: string;
        name: string;
    };
    created_at: string;
    modified_at: string;
    name: string;
    uic: string;
    external_customer_id: number | null;
    stripe_customer_id: number | null;
    address: string | null;
    tax_registration_number: string | null;
    representative: string | null;
    city: string | null;
    country: string | null;
    email: string | null;
    phone: string | null;
    language: LANGUAGE;
}

export type CustomerRetrieve = Customer & {
    configuration: {
        id: string;
        created_at: string;
        modified_at: string;
        invoice_grace_period_days: number | null;
        payment_provider: PAYMENT_PROVIDER;
        locale: LANGUAGE;
        currency: CURRENCY;
    }
}